/**
 * Resolve a platform's full-color brand icon from the local colored asset set
 * (src/assets/images/platforms/colored/*.svg), keyed by the icon's filename.
 *
 * Platform list entries carry a hosted (mono/white) `icon` URL; the colored
 * variants ship locally under the same filenames. We derive the filename from
 * that URL and look up the colored version, falling back to the original icon
 * when no colored match exists so nothing ever renders blank.
 *
 * @param {{ icon?: string, name?: string, template?: string }} plat
 * @returns {string|null}
 */
// Cache colored-asset lookups by filename so we resolve each once instead of
// calling require() (and throwing/catching for misses) on every render.
const iconCache = new Map()

function resolveColored(file) {
  if (iconCache.has(file)) return iconCache.get(file)
  let resolved = null
  try {
    resolved = require('@/assets/images/platforms/colored/' + file)
  } catch (e) {
    resolved = null
  }
  iconCache.set(file, resolved)
  return resolved
}

export function coloredPlatformIcon(plat) {
  if (!plat) return null

  let file = (plat.icon || '')
    .split('/')
    .pop()
    .split('?')[0]
    .replace(/\.png$/i, '.svg')

  // youtube events reuses the youtube brand mark
  if (plat.template === 'youtube events' || plat.name === 'youtube events') {
    file = 'youtube.svg'
  }

  return resolveColored(file) || plat.icon || null
}
